"use strict";

var _classCallCheck = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ticker = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _Core = require("./Core");

var _rx = require("./rx");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var requestTimer = typeof window === 'undefined' ? function () {
  var start = new Date().getTime();
  return function (cb) {
    return setTimeout(function () {
      return cb(new Date().getTime() - start);
    }, 1000 / 60);
  };
}() : function () {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var g = window; // eslint-disable-line no-undef
  // if ((g.performance && g.performance.now) instanceof Function) {
  //   return cb => g.requestAnimationFrame(() => cb(g.performance.now()));
  // }

  return g.requestAnimationFrame;
}();

var Ticker =
/*#__PURE__*/
function () {
  _createClass(Ticker, [{
    key: "each",
    // execute `fn` each tick.
    value: function each(fn) {
      this._running || this.autoStart && this.start();
      return this.pipe().subscribe(fn);
    } // execute `fn` once at next tick.

  }, {
    key: "once",
    value: function once(fn) {
      this._running || this.autoStart && this.start();
      return this.pipe((0, _operators.take)(1)).subscribe(fn);
    }
  }, {
    key: "start",
    //#endregion
    //#region controller
    // start ticker
    value: function start() {
      return this.core.events.start();
    } // pause ticker

  }, {
    key: "pause",
    value: function pause() {
      return this.core.events.pause();
    } //#endregion

    /**
     * Ticker.
     * if you create a new `Ticker`, then in most time you shoud registered it into `main` app by `pipeCore`.
     * @param id .
     * @param autoStart if `true` it would invoke `start()` automatically when `each`, `once` was called.
     * @param syncPeriod default is `100`, it will sync timer betweenn browser and back-end each `syncPeriod` millisecond.
     */

  }, {
    key: "now",
    //#region timer
    get: function get() {
      return this.time.now + this.time.offset;
    }
    /** now - pauseTime */

  }, {
    key: "runTime",
    get: function get() {
      return this.time.run;
    }
    /** now - lastTime, `0` if ticker not running. */

  }, {
    key: "deltaTime",
    get: function get() {
      return this.time.delta;
    }
  }, {
    key: "FPS",
    get: function get() {
      if (!this.time.delta) return 0;
      return 1000 / this.time.delta;
    }
  }, {
    key: "running",
    get: function get() {
      return this._running;
    }
  }]);

  function Ticker(id) {
    var _this = this;

    var autoStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var syncPeriod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

    _classCallCheck(this, Ticker);

    _defineProperty(this, "id", void 0);

    _defineProperty(this, "time", {
      now: 0,
      offset: 0,
      run: 0,
      delta: 0
    });

    _defineProperty(this, "autoStart", void 0);

    _defineProperty(this, "pipe", void 0);

    _defineProperty(this, "_running", false);

    _defineProperty(this, "core", void 0);

    this.id = id;
    this.autoStart = autoStart; //#region init core

    var core = function () {
      var subject = new _rxjs.Subject();
      var events = {
        start: function start() {
          return subject.next({
            running: true
          });
        },
        pause: function pause() {
          return subject.next({
            running: false
          });
        },
        sync: function sync(offset) {
          return subject.next({
            time: {
              offset: offset
            }
          });
        }
      };
      return new _Core.Core("_FURE_CORE_TICKER-".concat(id), events, subject);
    }();

    this.core = core; //#endregion
    //#region init timer

    var timer = new _rxjs.Subject();

    var render = function render(now) {
      var delta = now - _this.time.now;
      _this.time.now = now;
      _this.time.delta = 0;
      if (!_this._running) return;
      requestTimer(render);

      if (render.skipOnBack) {
        render.skipOnBack = false; // eslint-disable-next-line no-console

        console.info("timer#".concat(id, " skipped a frame about ").concat(delta, "ms because the window has hide."));
        return;
      }

      if (delta <= 0 || delta > 1000) return;
      _this.time.delta = delta;
      _this.time.run += delta;
      timer.next(delta);
    };

    core.pipe((0, _rx.pick)('running')).subscribe(function (running) {
      _this._running = running;
      running && requestTimer(render);
    });
    this.pipe = timer.pipe.bind(timer); //#endregion
    //#region sync ticker
    // backend.now == browser.now == browser.time.now + browser.time.offset

    if (typeof window === 'undefined') {
      syncPeriod > 0 && timer.pipe((0, _operators.throttleTime)(syncPeriod, _rxjs.asyncScheduler, {
        leading: true,
        trailing: false
      })).subscribe(function (_delta) {
        return core.events.sync(new Date().getTime() - _this.time.now);
      });
    } else {
      core.pipe((0, _rx.pick)('time')).subscribe(function (_ref) {
        var offset = _ref.offset;
        return _this.time.offset = new Date().getTime() - _this.time.now - offset;
      }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

      var g = window; // eslint-disable-line no-undef
      // listen visibility change event to skip the first frame after the window changed.

      (0, _rxjs.fromEvent)(g, 'visibilitychange').pipe((0, _operators.filter)(function () {
        return g.document.visibilityState === 'visible';
      })).subscribe(function (_visibile) {
        return render.skipOnBack = true;
      });
      render.skipOnBack = false;
    } //#endregion

  }

  return Ticker;
}();

exports.Ticker = Ticker;

_defineProperty(Ticker, "shared", new Ticker('shared', true));